<template>
  <section id="main-content">
    <template v-if="currentSubsModel == 'onhb'">
      <h1>
        Regulamento da 42ª <span class="caps">OMU</span>
        <!-- <span class="terms-update">Revisado e atualizado em ****</span> -->
      </h1>

      <article id="terms" class="generic-document">
        <p>
           Antes de prosseguir leia atentamente o <a href="https://www.olimpiada.ime.unicamp.br/elementos_visuais/arquivos/regulamento-2026.pdf" target="_blank">Regulamento da 42ª Olimpíada de Matemática da Unicamp</a>
        </p>
        <p>
          Tenha em mente que ao prosseguir e inscrever sua(s) equipe(s), isto significa que <strong>todos</strong> os participantes e envolvidos estão cientes do regulamento, e concordam em participar da Olimpíada dentro destes termos.
        </p>
        <p>
          Salientamos que, como consta no regulamento, A Olimpíada de Matemática da Unicamp (OMU) valoriza
          sua privacidade e está comprometida com a proteção dos seus dados pessoais. Este site utiliza
          cookies para melhorar sua experiência de navegação e para fins de análise e estatística.
          Coletamos informações como nome, e-mail, escola e dados de participação para possibilitar sua
          inscrição e acompanhamento nas edições da Olimpíada. Esses dados são tratados com segurança
          e confidencialidade, em conformidade com a Lei Geral de Proteção de Dados (LGPD).
          Ao clicar em "Seguir em frente" e continuar navegando, você concorda com o uso de cookies e com
          nossa Política de Privacidade completa.
        </p>
      </article>
    </template>
    <div id="agreement">
      <input type="checkbox" v-model="doWeHaveAnAgreement" id="agreementToTerms"/>
      <label
        for="agreementToTerms"
        class="generic-label"
      >Declaro ter lido e estar de acordo com todos os termos.</label>
    </div>

    <button
      :disabled="!doWeHaveAnAgreement"
      class="btn-main-action"
      @click="dispatchInvitedTeachers"
    >Seguir em frente
    </button>
  </section>
</template>

<script>
import store from "../../store";
import router from "../../router";
import {mapGetters} from "vuex";

export default {
  name: "StepTermsAndConditions",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentSubsStep", "currentSubsModel"]),
    doWeHaveAnAgreement: {
      get: function () {
        return store.state.Subscription.NewSuiApplication.extra_data
          ._onhbSubscription.agreedToTermsAndConditions;
      },
      set: function (value) {
        store.commit("CHANGE_AGREEMENT_STATUS", value);
      }
    }
  },
  methods: {
    dispatchInvitedTeachers: function (teachers) {
      store.dispatch("goToUserId").then(function () {
        router.push({
          name: "nothingButFlowers",
          params: {
            subsSlug: store.state.Subscription.subscription_slug,
            step: "user"
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/_mixins.scss";
@import "@/assets/static/css/_definitions.scss";

.generic-document {
  margin: pad(1) auto;
  max-width: unset;
  border-top: 2px solid grays(8);
  border-bottom: 2px solid grays(8);
  padding: pad(1) calc(50% - 40ch);
}

#agreement {
  padding-top: pad(2);
  margin-bottom: pad(2);

  .generic-label {
    margin-left: pad(-1);
  }
}

#warnings {
  @extend .white-box;
  box-shadow: none;
  background: none;
  margin-bottom: pad(0);

  h2 {
    @include fs(0);
    font-weight: bold;
    position: relative;
    top: -1 * pad(-1);
  }
}

.btn-main-action {
  margin-left: auto;
}

.tips {
  li {
    @extend .box-expander;

    & + li {
      border-top-color: grays(9.6);
      border-top-width: 3px;
    }

    &.important {
      background: secondary-color(0);
    }

    &:not(.important) {
      background: grays(9);
    }
  }
}

.terms-update {
  margin-top: pad(-1);
  opacity: 0.7;
  @include fs(-2);
  @extend .mono;
  display: block;
}

ul {
  li:before {
    content: "❥";
  }
}

ol {
  counter-reset: list-counter;

  li {
    counter-increment: list-counter;

    &:before {
      content: counter(list-counter, lower-alpha) ".";
    }
  }

  &.upper-roman li:before {
    content: counter(list-counter, lower-roman) ".";
  }
}

ul,
ol {
  li {
    position: relative;

    &:before {
      width: pad(0);
      left: -3/2 * pad(0);
      transform: unset !important;
      position: absolute;
      @extend .enumerator;
    }
  }
}

@include respond-below(md) {
  ol {
    li {
      &:before {
        display: block;
        width: auto;
        left: unset;
        position: static;
      }
    }
  }
  ul {
    li {
      padding-left: pad(-1) + pad(-2);

      &:before {
        width: pad(-1) + pad(-2);
        left: 0;
      }
    }
  }
}
</style>
